import React from "react"

export default () => (
    <footer className="footer">
        &copy; peteromalley.co.uk 2019
    </footer>
)